import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import React from 'react'

import './assets/css/global.css'
import './assets/css/rhybus.css'
import './assets/css/variables.css'
import './assets/icons/style.css'
import LoginPage from './login'
import  TokenExpirationHandler  from './pages/tokenexpiration/TokenExpirationHandler'
import Routers from './routers/router'
import { MetadataContextProvider } from './store/metadata-context-provider'
import { PreviousPageProvider } from './store/previous-page-provider'
import { RoleContextProvider } from './store/role-context-provider'
import { UserContextProvider } from './store/user-context-provider'

const App = () => {
  // NOTE: the UserContextProvider is where InitXSRFProtection() is
  // executed from the rhybus/api.  This must happen before any other
  // API calls are made.
  return (
    <>
    <TokenExpirationHandler/>
    <AuthenticatedTemplate>
      <UserContextProvider>
        <MetadataContextProvider>
          <RoleContextProvider>
            <PreviousPageProvider>
              <Routers />
            </PreviousPageProvider>
          </RoleContextProvider>
        </MetadataContextProvider>
      </UserContextProvider>
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate></>
      )
  
}

export default App
